/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAbsoluteNavViewProps } from './absolute-nav-item';

/**
 *
 * AbsoluteNavItemView component.
 * @extends {React.PureComponent<IAbsoluteNavViewProps>}
 */
export class AbsoluteNavItemView extends React.PureComponent<IAbsoluteNavViewProps> {
    public render(): JSX.Element | null {
        const { AbsoluteNavItem } = this.props;
        return (
            <Module {...AbsoluteNavItem}>
                {this._renderElement(this.props)}
            </Module>
        );
    }

    private _renderElement(props: IAbsoluteNavViewProps): React.ReactNode | null {
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink } = props;
        if (heading) {
            return (<Node {...HeadingContainer}>
                {' '}
                {heading}
                {' '}
            </Node>);
        } else if (Link && image) {
            return (
                <Node {...Link}>
                    {linkText}
                    {image}
                </Node>
            );
        } else if (Link) {
            return (EditableLink);
        }
        return (
            <>
                {text}
                {image}
            </>
        );
    }
}

export default AbsoluteNavItemView;
